import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-discord',
  templateUrl: './discord.component.html',
  styleUrls: ['./discord.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscordIconComponent {}
